import { isUserLoggedIn } from '../../utils/authUtils';
import { getPartialModel } from '../../utils/modelUtils';
import { CrudServiceBase } from '../base/crudServiceBase';
import { PagedResultDto } from '../dto/pagedResultDto';
import Endpoint from '../endpoint';
import { httpApi } from '../httpService';
import { DiscountCodeDto } from './dto/discountCodeDto';

export class DiscountCodeService extends CrudServiceBase<DiscountCodeDto> {
    constructor() {
        super(Endpoint.DiscountCode);
        this.internalHttp = httpApi;
    }

    public async create(createDiscountCodeInput: DiscountCodeDto) {
        isUserLoggedIn();

        let newCreateDiscountCodeInput = getPartialModel(createDiscountCodeInput, [], ['id', 'insurer', 'creationTime', 'countOfUses', 'creatorUserId', 'lastModificationTime', 'lastModifierUserId']);
        newCreateDiscountCodeInput.maxUsageCount = parseInt(newCreateDiscountCodeInput.maxUsageCount);

        let result = await this.internalHttp.post(this.endpoint.Create(), newCreateDiscountCodeInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async update(updateDiscountCodeInput: DiscountCodeDto) {
        isUserLoggedIn();

        let newUpdateDiscountCodeInput = getPartialModel(updateDiscountCodeInput, [], ['insurer', 'lastModificationTime', 'lastModifierUserId']);
        newUpdateDiscountCodeInput.maxUsageCount = parseInt(newUpdateDiscountCodeInput.maxUsageCount);

        let result = await this.internalHttp.put(this.endpoint.Update(), newUpdateDiscountCodeInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async delete(deleteDiscountCodeInput: DiscountCodeDto) {
      isUserLoggedIn();
      
      let newDeleteDiscountCodeInput = getPartialModel(deleteDiscountCodeInput, ['id'], []);

      let result = await this.internalHttp.delete(this.endpoint.Delete(), { params: newDeleteDiscountCodeInput });
      return result.data;
    }

    public async getInsurersForDiscountCodes(): Promise<PagedResultDto<any>> {
        isUserLoggedIn();

        let result = await this.internalHttp.get(this.endpoint.Custom('GetInsurersForDiscountCodes'));
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async getInsurerProductsForDiscountCodes(insurerId: number): Promise<PagedResultDto<any>> {
        isUserLoggedIn();

        let result = await this.internalHttp.get(this.endpoint.Custom(`GetInsurerProductsForDiscountCodes/?insurerId=${insurerId}`));
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }
}

const exportDiscountCodeService: DiscountCodeService = new DiscountCodeService();
export default exportDiscountCodeService;